import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ValidatorFn, AbstractControl, UntypedFormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../../services/globalsearchservice.service'
import { GlobalsService } from '../../../services/globals.service'
import { SystemService } from '../../../services/system.service'
import { GeneralLedgerService } from '../../../services/general-ledger.service'
import { InventoryService } from '../../../services/inventory.service'
import { trigger, state, style, transition, animate } from '@angular/animations';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ThisReceiver } from '@angular/compiler';
import { Console } from 'console';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-free-gift',
	templateUrl: './free-gift.component.html',
	styleUrls: ['./free-gift.component.scss']
})
export class FreeGiftComponent {

	@ViewChild('addGiftModal') addGiftRef: ElementRef;
	@ViewChild('editGiftModal') editGiftRef: ElementRef;
	
	giftname: any = new UntypedFormControl('');
	giftdesc: any = new UntypedFormControl('');
	giftstart: any = new UntypedFormControl('');
	giftend: any = new UntypedFormControl('');
	giftthresh: any = new UntypedFormControl('');
	giftloc: any = new UntypedFormControl('');
	giftman: any = new UntypedFormControl('0');
	egiftname: any = new UntypedFormControl('');
	egiftdesc: any = new UntypedFormControl('');
	egiftstart: any = new UntypedFormControl('');
	egiftend: any = new UntypedFormControl('');
	egiftthresh: any = new UntypedFormControl('');
	egiftloc: any = new UntypedFormControl('');
	egiftman: any = new UntypedFormControl('');
	
	user: any = false;
	freegifts: any = [];
	editinggift: any = [];
	manufacturers: any = [];
	locations: any = [];
	
	constructor(private systemService: SystemService, private globalsService: GlobalsService, private modalService: NgbModal, private inventoryService: InventoryService, private globalSearchService: GlobalSearchService) {
		this.systemService.getFreeGifts().subscribe(async (results: any) => {
			if(results) {
				this.freegifts = results;
			} 
		});
		this.globalSearchService.user.subscribe(results => {

			this.user = results
		});
		this.globalsService.getLocations().subscribe((results: any) => {
			this.locations = results;
		});
		this.inventoryService.getItemManufacturer().subscribe(async results => {
			this.manufacturers = results;
		});
	}
	
	addFreeGift() {
		this.giftname.value = '';
		this.giftdesc.value = '';
		this.giftstart.value = '';
		this.giftend.value = '';
		this.giftthresh.value = '';
		this.giftman.value = '0';
		this.giftloc.value = '';
		this.modalService.open(this.addGiftRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			
		});
	}
	
	addGift(){

		const data = { 'threshold': this.giftthresh.value, 'name': this.giftname.value, 'description': this.giftdesc.value, 'mfg': this.giftman.value, 'loccode': this.giftloc.value, 'startdate': this.giftstart.value, 'enddate': this.giftend.value };
		
		this.systemService.addFreeGiftSettings(data).subscribe(async (results: any) => {
			if(!results.error) {
				this.freegifts = results
				this.modalService.dismissAll();
				this.globalSearchService.showNotification('Gift Settings added', 'success', 'bottom', 'right');
			} else {
				this.globalSearchService.showNotification(results.error, 'danger', 'bottom', 'right');
			}
		});
	
	}
	
	updateGift(){
	
		const data = { 'id': this.editinggift.id, 'items':this.editinggift.items, 'threshold': this.egiftthresh.value, 'name': this.egiftname.value, 'mfg': this.egiftman.value, 'loccode': this.egiftloc.value, 'description': this.egiftdesc.value, 'startdate': this.egiftstart.value, 'enddate': this.egiftend.value };
		
		this.systemService.updateFreeGiftSettings(data).subscribe(async (results: any) => {
			if(!results.error) {
				this.freegifts = results
				this.modalService.dismissAll();
				this.globalSearchService.showNotification('Gift Settings updated', 'success', 'bottom', 'right');
				this.editinggift = [];
			} else {
				this.globalSearchService.showNotification(results.error, 'danger', 'bottom', 'right');
			}
		});
	}
	
	editGift(s: any){
	
		this.editinggift = s;
		this.egiftname.value = s.name;
		this.egiftdesc.value = s.description;
		this.egiftstart.value = s.startdate;
		this.egiftend.value = s.enddate;
		this.egiftthresh.value = s.threshold;
		this.egiftman.setValue(s.mfg);
		this.egiftloc.value = s.loccode;
		
	}
	addItems(list: any){
	
		console.log(list);
		list.forEach(i => {
			const newitem = { stockid: i.stockid, description: i.description };
			this.editinggift.items.push(newitem);
		});
	}
	deleteGift(id: any){
	
		const data = { 'id': id };
		
		this.systemService.removeFreeGiftSettings(data).subscribe(async (results: any) => {
			if(!results.error) {
				this.freegifts = results;
				this.globalSearchService.showNotification('Gift Settings deleted', 'success', 'bottom', 'right');
			} else {
				this.globalSearchService.showNotification(results.error, 'danger', 'bottom', 'right');
			}
		});
	}
}
